package com.gastoncantera.intercom

import com.gastoncantera.intercom.config.Consorcio

data class LocationGateTarget(val lat: Double, val lng: Double, val radiusMeters: Double)

/**
 * Gate de ubicación EXCLUSIVO de web. [targets] son consorcios con `ubicacion` `lat,lng,radio`;
 * si está vacío no hay gate.
 *
 * En web: exige dispositivo móvil, pide compartir ubicación (pantalla propia) y, si el dispositivo
 * no está dentro del radio de alguna [targets], muestra pantalla de denegación y no retorna.
 * En Android/iOS es no-op.
 */
expect suspend fun enforceLocationGate(targets: List<LocationGateTarget>)

/**
 * `"lat,lng,radio"` (radio en metros, `> 0`). Sin el tercer valor, radio inválido o string vacío → null
 * (QR de ese consorcio deshabilitado).
 */
fun parseLocationGateTarget(raw: String?): LocationGateTarget? {
    if (raw.isNullOrBlank()) return null
    val parts = raw.split(',').map { it.trim() }
    if (parts.size != 3) return null
    val lat = parts[0].toDoubleOrNull() ?: return null
    val lng = parts[1].toDoubleOrNull() ?: return null
    val radius = parts[2].toDoubleOrNull() ?: return null
    if (radius <= 0.0) return null
    return LocationGateTarget(lat, lng, radius)
}

fun List<Consorcio>.locationGateTargets(): List<LocationGateTarget> =
    mapNotNull { parseLocationGateTarget(it.ubicacion) }
